import React from "react";
import Table from '../maintenance/TableBuilder';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import TenantsService from '../../../services/TenantsService';
import RubsSearchSelect from "../../UI/organisms/RubsSearchSelect";

const CalcReview = (params) => {
  const {
    dataResult,
    activeStep,
    setActiveStep,
    filterTenantId,
    setFilterTenantId,
    reset,
  } = params;

  if (!dataResult) {
    return <div>Loading...</div>;
  }

  const handleChooseDetail = (event) => {
    setActiveStep(event.target.value);
  };
  const generateXLS = () => {
    setActiveStep("generateXLS");
  };

  const selectValue = activeStep ? activeStep : "periodUtilityDistribution";
  const selectFilterTenantId = (tenantId) => {
    setFilterTenantId(tenantId);
  }
  const optionMapFunction = (item) => {
    return item["lease_name"];
  };
  const searchSelectionMatcher = (item, selection) => {
    return item["lease_name"] === selection;
  };

  return <div>
    <div style={{display:"flex"}}>
      <Button onClick={reset}>Reset</Button>
      <Button style={{marginLeft:"20px"}}
              onClick={generateXLS}
      >Generate XLS</Button>
    </div>
    <span>
      Review the calculated charges:
      <Select value={selectValue}
              onChange={handleChooseDetail}
      >
        <MenuItem value="periodUtilityDistribution">Period Utility Distribution</MenuItem>
        <MenuItem value="totalCostSummary">Total Cost Summary</MenuItem>
        <MenuItem value="tenantUtilityCostSummary">Tenant Utility Cost Summary</MenuItem>
        {/*SAMI-108 <MenuItem value="feeProration">Fee Proration</MenuItem>*/}
        <MenuItem value="dailyUtilityDistributionRegistry">Daily Utility Distribution Registry</MenuItem>
        <MenuItem value="dailyTenantRegistry">Daily Tenant Registry</MenuItem>
        <MenuItem value="dailyCostPerUnitPerBill">Daily Cost Per Unit Per Bill</MenuItem>
        <MenuItem value="relevantBills">Relevant Utility Bills</MenuItem>
        <MenuItem value="relevantMeters">Relevant Meter Readings</MenuItem>
        {/*SAMI-108 <MenuItem value="relevantFees">Relevant Fees</MenuItem>*/}
        <MenuItem value="billsImport">Bills Import</MenuItem>
        <MenuItem value="finalBills">Final Bills</MenuItem>
        <MenuItem value="finalBillsTenants">Final Bills Tenants</MenuItem>
        <MenuItem value="finalBillsMostRecentBills">Final Bills Most Recent Bills</MenuItem>
        <MenuItem value="finalBillsDailyRegistry">Final Bills Daily Registry</MenuItem>
      </Select>
    </span>
    <span style={{marginLeft:"20px"}}>
      (Optional) Filter to tenant:
      <span style={{
        width:"25%",
        display:"inline-block",
        verticalAlign:"bottom",
      }}>
        <RubsSearchSelect dataService={TenantsService}
                          onSelected={selectFilterTenantId}
                          optionMapFunction={optionMapFunction}
                          searchSelectionMatcher={searchSelectionMatcher}
                          label="tenantLookup"
                          preloadId={filterTenantId}
        />
      </span>
      <span style={{cursor:"pointer",marginLeft:"5px"}} onClick={e=>setFilterTenantId(null)}>
        <img src="/icons/delete_001.png" width="16" height="16" alt="clear selection" />
      </span>
    </span>
    <span>

    </span>
    <Table data={dataResult} />
  </div>;
};

export default CalcReview;